import type { ReactNode } from 'react';
import { memo } from 'react';
import { Header, Text, VStack } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { getRequestContext } from '../../lib/requestContext';

export interface FeedbackBlankProps extends TestProps {
    /**
     * Компонент сверху над заголовками
     */
    header?: ReactNode;
    /**
     * заголовок
     */
    title?: string;
    /**
     * Подзаголовок
     */
    subtitle?: string | ReactNode;
    /**
     * Дополнительные элементы кнопки под заголовками
     */
    controls?: ReactNode;
}

/**
 * Базовый элемент отображения сообщения
 * @kind component
 */
export const FeedbackBlank = memo<FeedbackBlankProps>(function MessageBlank(props) {
    const { 'data-testid': dataTestId = 'MessageBlank', header, title, subtitle, controls } = props;
    const hasControls = Boolean(controls);
    const { traceId } = getRequestContext();

    return (
        <VStack data-testid={dataTestId} gap="28" alignItems="center">
            <VStack gap="20" alignItems="center">
                {header}
                {title && (
                    <Header level="h2" caption={subtitle} textAlign="center">
                        {title}
                    </Header>
                )}
                <Text role="supplementary" color="gray">
                    {traceId}
                </Text>
            </VStack>
            {hasControls && <VStack gap="16">{controls}</VStack>}
        </VStack>
    );
});
